var _module               = require('../../components/module');
var moment                = require('moment');
var shortid               = require('shortid');
var _                     = require('lodash');
var $whyAndWhyNot         = require('../../../libs/why-this-home');
var $matchScore           = require('../../../libs/match-score');
var listingsFilters       = require('./listings-filters');
var searchListingsFilters = require('../search/listings-filters');

require('../search');
require('../transform');

_module.factory('SearchFilter', [
    '$log',
    '$rootScope',
    '$http',
    '$q',
    '$search',
    '$transform',
    '$babou',

    function searchFilterFactory($log, $rootScope, $http, $q, $search, $transform, $babou) {
        function SearchFilter(props) {
            if(!props) props = {};

            this.id = shortid.generate();
            this.params = [];
            this.search_term = '';
            this.name = '';
            this.ownerId = null;
            this.isNew = props.id ? false : true;

            if(props) {
                Object.keys(props).reduce(function (obj, key) {
                    if(!~['results', 'results_map'].indexOf(key)) {
                        obj[key] = props[key];
                    }

                    return obj;
                }, this);
            }
        }

        ///////////////////////
        // Static Properties
        ///////////////////////
        SearchFilter.SEARCH_FILTER_SAVED = 'SearchFilter:Saved';
        SearchFilter.SEARCH_FILTER_DELETED = 'SearchFilter:Deleted';


        ///////////////////////
        // Internal Functions
        ///////////////////////

        /*
        Returns an object containing only keys that
        can be saved to the database / localstorage

        @function _getSavableObj
        */
        SearchFilter.prototype._getSavableObj = function _getSavableObj() {
            var _this = this;
            var propExceptions = [
                'searchFilterResultId',
                'filtered_count',
                'count',
                'results_map',
                'results',
                'isNew'
            ];
            var data = Object.keys(this).reduce(function reduceData(obj, key) {
                if(!~propExceptions.indexOf(key) && _this[key] !== null) {
                    obj[key] = _this[key];
                }

                return obj;
            }, {});

            return data;
        };


        //////////////////////
        // Public Functions
        //////////////////////

        /*
        Adds a filter

        @function addFilter
        @param {String} name - The filter property name
        @param {String|Number|Boolean} value - The value the should be filtered.
        */
        SearchFilter.prototype.addFilter = function addFilter(name, value) {
            var filter = {
                name: name,
                value: value
            };
            var foundPreviousParamIndex = _.findIndex(this.params, { name: name });

            if(~foundPreviousParamIndex) {
                this.params.splice(foundPreviousParamIndex, 1);
            }

            this.params.push(filter);
        };


        /*
        Reset a filter's params to an empty array
        This is mainly used for clean-up before updating
        an existing filter with new params

        @function resetParams
        */
        SearchFilter.prototype.resetParams = function resetParams() {
            this.params.length = 0;
        };


        /*
        Saves a filter

        @function saved
        */
        SearchFilter.prototype.save = function save() {
            var _this = this;
            var isNew = this.isNew;
            var data =  this._getSavableObj();

            return $http.put('/v1/searchfilters/' + this.id, data)
            .then(function onSaveSuccess(response) {
                _this.isNew = false;
                $rootScope.$broadcast(SearchFilter.SEARCH_FILTER_SAVED, _this, isNew);

                return response.data.data;
            });
        };

        /*
        Deletes the filter

        @function delete
        */
        SearchFilter.prototype.delete = function deleteFilter() {
            var _this = this;

            return $http.delete('/v1/searchfilters/' + this.id)
            .then(function deleteResponse(response) {
                $rootScope.$broadcast(SearchFilter.SEARCH_FILTER_DELETED, _this);

                return response.data.data;
            });
        };

        /*
        Runs a listing through the filter and
        gives back the reankings

        @function rankListing
        @param {Listing} listing
        @returns {Number} match_score
        */
        SearchFilter.prototype.rankListing = function rankListing(listing) {
            var matchScore = 100;
            var filteredListing = _.find(this.results, { id: listing.id });

            if(filteredListing) {
                return filteredListing.match_score;
            }

            return $matchScore.get(listing, this.params);
        };

        /*
        Returns the reasons why and why not

        @function whyAndWhyNot
        @param {Listing} listing
        */
        SearchFilter.prototype.whyAndWhyNot = function whyAndWhyNot(listing, sampleSize) {
            var why = [];
            var whyNot = [];
            if(!sampleSize) sampleSize = 3;

            try {
                if(this.params.length > 0) {
                    var response;

                    this.params.forEach(function forEachScore(filterItem) {
                        if(filterItem.name === 'price' && listing.price) {
                            response = $whyAndWhyNot(listing, $matchScore.calcPrice(listing, filterItem.value).metWhyWhyNotThreshold, filterItem.name, filterItem.value);
                        } else if(filterItem.name === 'whatsimportant' && listing.reports && Object.keys(listing.reports).length > 0) {
                            response = $whyAndWhyNot(listing, $matchScore.calcWhatsImportant(listing, filterItem.value).metWhyWhyNotThreshold, filterItem.name, filterItem.value);
                        } else if(filterItem.name === 'schools' && listing.reports && Object.keys(listing.reports).length > 0) {
                            response = $whyAndWhyNot(listing, $matchScore.calcSchools(listing, filterItem.value).metWhyWhyNotThreshold, filterItem.name, filterItem.value);
                        } else if(filterItem.name === 'hometype' && listing.sub_type) {
                            response = $whyAndWhyNot(listing, $matchScore.calcHomeType(listing, filterItem.value).metWhyWhyNotThreshold, filterItem.name, filterItem.value);
                        } else if(filterItem.name === 'bedrooms' && listing.beds) {
                            response = $whyAndWhyNot(listing, $matchScore.calcBeds(listing, filterItem.value).metWhyWhyNotThreshold, filterItem.name, filterItem.value);
                        } else if(filterItem.name === 'bathrooms' && listing.baths) {
                            response = $whyAndWhyNot(listing, $matchScore.calcBaths(listing, filterItem.value).metWhyWhyNotThreshold, filterItem.name, filterItem.value);
                        } else if(filterItem.name === 'age' && listing.year) {
                            response = $whyAndWhyNot(listing, $matchScore.calcAge(listing, filterItem.value).metWhyWhyNotThreshold, filterItem.name, filterItem.value);
                        } else if(filterItem.name === 'stories' && listing.floors) {
                            response = $whyAndWhyNot(listing, $matchScore.calcStories(listing, filterItem.value).metWhyWhyNotThreshold, filterItem.name, filterItem.value);
                        } else if(filterItem.name === 'sqfeet' && listing.home_size) {
                            response = $whyAndWhyNot(listing, $matchScore.calcSqft(listing, filterItem.value).metWhyWhyNotThreshold, filterItem.name, filterItem.value);
                        } else if(filterItem.name === 'lotsize' && listing.lot_size) {
                            response = $whyAndWhyNot(listing, $matchScore.calcLotSize(listing, filterItem.value).metWhyWhyNotThreshold, filterItem.name, filterItem.value);
                        } else {
                            response = false;
                        }

                        if(response) {
                            if(response.type === 'why') {
                                why.push(response);
                            } else {
                                whyNot.push(response);
                            }
                        }
                    });
                }
            } catch (err) {
                $log.error('whyAndWhyNot Error:', err);
            }

            return {
                why: _.sampleSize(why, sampleSize),
                whyNot: _.sampleSize(whyNot, sampleSize)
            };
        };

        /**
         * Returns a paginated list of results
         *
         * @function getListings
         * @param {Object} [options={}]
         * @param {int} [options.page=1]
         * @param {int} [options.limit=50]
         * @param {String} [options.orderby='match_score:desc']
         */
        SearchFilter.prototype.getListings = function getListings(options) {
            var defOptions = {
                page: 1,
                limit: 50,
                orderby: 'match_score:desc'
            };
            var opt = _.merge(defOptions, options);
            opt.skip = (opt.page - 1) * opt.limit;

            opt.include_listings = true;
            opt.include_listing_stats = false;
            opt.useSourceZipBlacklist = true;
            opt.orderBy = opt.orderby;
            opt.orderby = undefined;
            if(!opt.bypasscache) delete opt.bypasscache;
            opt.search_filter_params = this.params;

            var result =  $http({
                method: 'GET',
                url:'/v1/search/area',
                params: {searchTerm: this.search_term}
            }).then(function(res) {
                var areas = [
                    res.data.data
                ];
                return $babou.searchListings(areas, opt);
            });

            return result.then(function(response) {
                var listings = [];
                response.data.page.listings.forEach(function(listing){
                    $babou.formatListingFields(listing,listings);
                });
                response.data.page.listings = listings;
                return response.data.page;
            }).catch(function onError(err){
                $log.error(err);
                return [];
            });
        };


        // Return our class
        return SearchFilter;
    }
]);
